import * as PIXI from "pixi.js";
import Library   from "../utils/Library";

export default class SpriteWithColorFilter extends PIXI.Sprite
{

    get contrast()
    {
        return this.uniforms.contrast;
    }

    set contrast(contrast)
    {
        this.uniforms.contrast = contrast;
    }

    get exposure()
    {
        return this.uniforms.exposure;
    }

    set exposure(exposure)
    {
        this.uniforms.exposure = exposure;
    }

    get gamma()
    {
        return this.uniforms.gamma;
    }

    set gamma(gamma)
    {
        this.uniforms.gamma = gamma;
    }


    get saturation()
    {
        return this.uniforms.saturation;
    }

    set saturation(saturation)
    {
        this.uniforms.saturation = saturation;
    }

    get temperature()
    {
        return this.uniforms.temperature;
    }

    set temperature(temperature)
    {
        this.uniforms.temperature = temperature;
    }


    constructor(props)
    {
        super(props);

        let shader = Library.instance.geShaderByKey("colorize");
        this.uniforms = {exposure: 0, gamma: 0, saturation: 1.0, contrast: 1.0, temperature: 0.0};
        this.shader = new PIXI.Filter(null, shader, this.uniforms);

        // this.shaderSaturation = Library.instance.geShaderByKey("saturation");
        // this.shaderSaturation = new PIXI.Filter(null, this.shaderSaturation, this.uniforms);

        //mt20240521
        //this.filters = [this.shader];

    }

}
